module.exports = __webpack_public_path__ + "img/f3aee8a.svg";